"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangesClaim = exports.ChangesBasePerson = void 0;
class ChangesBasePerson {
}
exports.ChangesBasePerson = ChangesBasePerson;
class ChangesClaim {
}
exports.ChangesClaim = ChangesClaim;
//# sourceMappingURL=ChangesBasePerson.js.map